import { createAction } from 'typesafe-actions';

export const secondaryMarketOfferCreatedAction = createAction('SECONDARY_MARKET_OFFER_CREATED')<void>();
export const secondaryMarketOfferErrorAction = createAction('SECONDARY_MARKET_OFFER_ERROR')<void>();
export const secondaryMarketOfferCanceledAction = createAction('SECONDARY_MARKET_OFFER_CANCELED')<void>();
export const secondaryMarketOffersModalClosedAction = createAction('SECONDARY_MARKET_OFFERS_MODAL_CLOSED')<void>();

export const secondaryMarketBidAcceptedAction = createAction('SECONDARY_MARKET_BID_ACCEPTED')<void>();
